var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadioOutlinedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill-background",
    d: "M10 0.5C4.75586 0.5 0.5 4.75586 0.5 10H1.5C1.5 5.30814 5.30814 1.5 10 1.5V0.5ZM0.5 10C0.5 15.2441 4.75586 19.5 10 19.5V18.5C5.30814 18.5 1.5 14.6918 1.5 10H0.5ZM10 19.5C15.2441 19.5 19.5 15.2441 19.5 10H18.5C18.5 14.6918 14.6919 18.5 10 18.5V19.5ZM19.5 10C19.5 4.75586 15.2441 0.5 10 0.5V1.5C14.6919 1.5 18.5 5.30815 18.5 10H19.5ZM10.0003 16.7003C6.29844 16.7003 3.30029 13.7021 3.30029 10.0003H2.30029C2.30029 14.2544 5.74615 17.7003 10.0003 17.7003V16.7003ZM3.30029 10.0003C3.30029 6.29843 6.29844 3.30029 10.0003 3.30029V2.30029C5.74615 2.30029 2.30029 5.74615 2.30029 10.0003H3.30029ZM10.0003 3.30029C13.7021 3.30029 16.7003 6.29843 16.7003 10.0003H17.7003C17.7003 5.74615 14.2544 2.30029 10.0003 2.30029V3.30029ZM16.7003 10.0003C16.7003 13.7021 13.7021 16.7003 10.0003 16.7003V17.7003C14.2544 17.7003 17.7003 14.2544 17.7003 10.0003H16.7003Z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioOutlinedIcon);
export default __webpack_public_path__ + "static/media/radioOutlinedIcon.27c90591.svg";
export { ForwardRef as ReactComponent };